import type React from "react";

import { getThemeClass, getThemeComponentGroup } from "@/shared/lib/themeComponentClasses";

type MenuAction = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
};

type MenuPanelProps = {
  panelRef: React.RefObject<HTMLDivElement>;
  displayName: string;
  actions: MenuAction[];
};

export function MenuPanel({ panelRef, displayName, actions }: MenuPanelProps) {
  const menuClasses = getThemeComponentGroup("menu");

  return (
    <div
      ref={panelRef}
      role="menu"
      className={`absolute right-0 mt-2 w-56 sm:w-64 rounded-xl border shadow-xl z-50 overflow-hidden ${getThemeClass(menuClasses.panelBorderColor, "border-theme-border/60")} ${getThemeClass(menuClasses.panelBgColor, "bg-theme-surface")} ${getThemeClass(menuClasses.panelTextColor, "text-theme-text")}`}
    >
      <div
        className={`px-4 py-3 ${getThemeClass(menuClasses.headerBgColor, "bg-theme-accent-soft")}`}
      >
        <p
          className={`text-xs ${getThemeClass(menuClasses.headerTextColor, "text-theme-text/70")}`}
        >
          Signed in as
        </p>
        <p
          className={`text-sm font-semibold truncate ${getThemeClass(menuClasses.panelTextColor, "text-theme-text")}`}
        >
          {displayName || "User"}
        </p>
      </div>

      <div className="py-1">
        {actions.map((action, idx) => (
          <button
            key={idx}
            role="menuitem"
            onClick={action.onClick}
            disabled={action.disabled}
            className={
              action.className ??
              `w-full flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors disabled:opacity-60 disabled:cursor-not-allowed ${getThemeClass(menuClasses.itemTextColor, "text-theme-text-muted")} ${getThemeClass(menuClasses.itemHoverBgColor, "hover:bg-theme-surface-muted")}`
            }
          >
            {action.icon}
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
}
